import { Table, Tag, Space, message } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { AddEditComponent } from "./AddEditComonent";
import EditButton from "../../UI/EditButton/editbutton";
import DeleteButton from "../../UI/DeleteButton/deletebutton";
import { ComponentType } from "./componentType";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { deleteComponent, getComponentById } from "../../../api/refcomponents";
import DeleteModal from "../../UI/ModalComponent/DeleteModal/deletemodal";
import { AxiosResponse } from "axios";

interface inventoryProps {
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  filter: boolean | undefined;
  search: string;
  istComponentLoading: boolean;
  paginatedtComponent: any;
  setPaginatedtComponent: Dispatch<any>;
  ComponentMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  tableKey: string;
}
interface ComponentInterface {
  id: string;
  name: string;
  isActive: boolean;
}
const ComponentList = ({
  page,
  search,
  setPage,
  filter,
  istComponentLoading,
  paginatedtComponent,
  setPaginatedtComponent,
  ComponentMutation,
  tableKey,
}: inventoryProps) => {
  const [t] = useTranslation("common");
  const [selectComponent, setSelectedComponent] = useState<any>();
  const [openComponent, setOpenComponent] = useState(false);
  const [component, setComponent] = useState<ComponentType>();
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);
  const getComponentMutation = useMutation("getComponen", getComponentById);
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [nameToDelete, setNameToDelete] = useState<any>();
  const [, setError] = useState("");

  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      ComponentMutation({
        limit: page * 8 + 8,
        q: search,
        isActive: filter,
      }).then((res) => {
        if (page > maxPage) setMaxPage(page);
        setPaginatedtComponent(res.data?.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filter]);

  const onError = (error: any, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };

  function fillComponent(id: any) {
    getComponentMutation.mutate(id, {
      onSuccess: (res) => {
        setComponent(res.data);
        setOpenComponent(true);
      },
    });
  }

  const deleteComponentMutation = useMutation(
    "deleteComponent",
    deleteComponent,
    {
      onSuccess: () => {
        ComponentMutation({
          limit: page * 8 + 8,
          q: search,
          isActive: filter,
        }).then((res) => {
          setPaginatedtComponent(res.data?.data);
          message.success("Complete successfully");
        });
      },
      onError,
    }
  );

  const DeleteCurrency = (id: string | undefined, name: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(name);
  };

  const handleOk = () => {
    if (idToDelete) {
      deleteComponentMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const columns: ColumnsType<ComponentInterface> = [
    {
      title: `${t("component")}`,
      dataIndex: "name",
      key: "name",
      className: "table-header",
    },
    {
      title: `${t("status")}`,
      dataIndex: "isActive",
      align: "center",
      width: "5rem",
      key: "isActive",
      render: (record: any) =>
        record ? (
          <Tag className="active">Active</Tag>
        ) : (
          <Tag className="inactive">Inactive</Tag>
        ),
    },
    {
      title: `${t("action")}`,
      key: "action",
      fixed: "right",
      width: "5rem",
      align: "center",
      render: (record: any) => (
        <Space>
          <EditButton
            onClick={() => {
              setSelectedComponent(record.id);
              fillComponent(record.id);
            }}
          />
          <DeleteButton
            onClick={() => DeleteCurrency(record?.id, record?.name)}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
      {openComponent && component && (
        <AddEditComponent
          component={component}
          openComponent={openComponent}
          setOpenComponent={setOpenComponent}
          id={selectComponent}
          setPaginatedtComponent={setPaginatedtComponent}
          ComponentMutation={ComponentMutation}
          page={page}
          filter={filter}
          search={search}
        />
      )}

      <Table
        key={tableKey}
        columns={columns}
        dataSource={paginatedtComponent}
        loading={istComponentLoading}
        pagination={{ pageSize: 8 }}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        rowKey={(record) => record.id}
      />
    </>
  );
};

export default ComponentList;
